export default {
	Active: "Active",
	Inactive: "Inactive",
	RequiredField: "Required field",
	Close: "Close",
	Copy: "Copy",
	Copied: "Copied",
	CopiedToClipboard: "Copied to clipboard",
	CopiedError: "Error copying",
	Duplicate: "Duplicate",
	With: "with",
	Date: "Date",
	Hour: "Time",
	And: " and ",
	All: "All",
	Recent: "Recent",
	Check: "Check out",
	ServiRoutes: "ServiRoutes",
	Clear: "Clean",
	Filters: "Filters",
	Go: "Go",
	Ago: "Ago",
	To: "to",
	Next: "Next",
	Previous: "Previous",
	Information: "Information",
	Options: "Options",
	Selection: "Selection",
	Serviform: "Serviforms",
	Serviroute: "Serviroute",
	ServiApps: "Servi Apps",
	Username: "Username",
	Lastname: "Lastname",
	Email: "Email",
	Role: "Role",
	Status: "Status",
	Type: "Type",
	New: "New",
	Help: "Help",
	Replace: "Replace",
	Name: "Name",
	Days: "Days",
	Locate: "Locate",
	ErrorTitle: "An error occurred",
	ErrorMessage: "An error occurred. Please try again!",
	Enter: "Enter",
	ContactPerson: "Contact Person",
	Country: "Country",
	City: "City",
	Department: "Department",
	Province: "Province",
	Region: "Region",
	State: "State",
	Canton: "Canton",
	Municipality: "Municipality",
	District: "District",
	Commune: "Commune",
	Description: "Description",
	InitDate: "Init Date",
	EndDate: "End Date",
	InitHour: "Init Hour",
	EndHour: "End Hour",
	Address: "Address",
	Identification: "Identification",
	Phone: "Phone",
	Submit: "Submit",
	Accept: "Accept",
	Cancel: "Cancel",
	Reset: "Reset",
	Action: "Action",
	Actions: "Actions",
	AddNew: "Add New",
	AddNew2: "Add New",
	Add: "Add",
	Start: "Beginning",
	End: "Closing",
	Startandend: "Beginning and Closing",
	Update: "Update",
	Dashboard: "Dashboard",
	eCommerce: "eCommerce",
	Apps: "Apps",
	Todo: "Todo",
	Calendar: "Calendar",
	FullCalendar: "Full Calendar",
	SimpleCalendar: "Simple Calendar",
	Shop: "Shop",
	ItemDetails: "Item Details",
	Cart: "Cart",
	WishList: "Wish List",
	Checkout: "Checkout",
	UI: "UI",
	DataList: "Data List",
	ListView: "List View",
	ThumbView: "Thumb View",
	Grid: "Grid",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Colors",
	Card: "Card",
	Basic: "Basic",
	Analytics: "Analytics",
	CardActions: "Card Actions",
	CardColors: "Card Colors",
	Table: "Table",
	agGridTable: "agGrid Table",
	Components: "Components",
	Alert: "Alert",
	Avatar: "Avatar",
	Badge: "Badge",
	Breadcrumb: "Breadcrumb",
	Button: "Button",
	ButtonGroup: "Button Group",
	Chip: "Chip",
	Collapse: "Collapse",
	Dialogs: "Dialogs",
	Divider: "Divider",
	DropDown: "DropDown",
	List: "List",
	Loading: "Loading",
	Navbar: "Navbar",
	Notifications: "Notifications",
	Pagination: "Pagination",
	Popup: "Popup",
	Progress: "Progress",
	Sidebar: "Sidebar",
	Slider: "Slider",
	Tabs: "Tabs",
	Tooltip: "Tooltip",
	Upload: "Upload",
	Manage: "Manage",
	FormsAndTable: "Forms & Table",
	FormElements: "Form Elements",
	Select: "Select",
	SelectAll: "Select All",
	Deselect: "Deselect All",
	Switch: "Switch",
	Checkbox: "Checkbox",
	Required: "Required",
	Radio: "Radio",
	Input: "Input",
	NumberInput: "Number Input",
	Textarea: "Textarea",
	FormLayouts: "Form Layouts",
	FormWizard: "Form Wizard",
	FormValidation: "Form Validation",
	FormInputGroup: "Form Input Group",
	Pages: "Pages",
	Authentication: "Authentication",
	Register: "Register",
	ForgotPassword: "Forgot Password",
	LockScreen: "Lock Screen",
	Miscellaneous: "Miscellaneous",
	ComingSoon: "Coming Soon",
	Error: "Error",
	404: "404",
	500: "500",
	NotAuthorized: "Not Authorized",
	Maintenance: "Maintenance",
	Profile: "Profile",
	Logout: "Logout",
	User: "User",
	View: "View",
	Edit: "Edit",
	UserSettings: "User Settings",
	CompanySettings: "Company Settings",
	Invoice: "Invoice",
	FAQ: "FAQ",
	Search: "Search",
	SearchBy: "Search by",
	SearchOn: "Search on",
	CurrentPage: "Current page",
	AllPages: "All pages",
	KnowledgeBase: "Knowledge Base",
	ChartsAndMaps: "Charts & Maps",
	Charts: "Charts",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensions",
	QuillEditor: "Quill Editor",
	DragAndDrop: "Drag & Drop",
	Datepicker: "Datepicker",
	DatetimePicker: "Datetime Picker",
	AccessControl: "Access Control",
	I18n: "I18n",
	Carousel: "Carousel",
	Clipboard: "Clipboard",
	ContextMenu: "Context Menu",
	StarRatings: "Star Ratings",
	Autocomplete: "Autocomplete",
	Tree: "Tree",
	Import: "Import",
	Export: "Export",
	Selected: "Selected",
	ExportSelected: "Export Selected",
	ExportAll: "Export All",
	CellAutoWidth: "Cell Auto Width",
	EnterFileName: "Enter File Name",
	Others: "Others",
	MenuLevels: "Menu Levels",
	MenuLevel2p1: "Menu Level 2.1",
	MenuLevel2p2: "Menu Level 2.2",
	MenuLevel3p1: "Menu Level 3.1",
	MenuLevel3p2: "Menu Level 3.2",
	DisabledMenu: "Disabled Menu",
	Support: "Support",
	Documentation: "Documentation",
	RaiseSupport: "Raise Support",
	demoTitle: "Card Title",
	demoText:
		"Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
	ExportToExcel: "Export to Excel",
	Map: "Map",
	Programed: "PROGRAMED",
	Executed: "EXECUTED",
	Both: "BOTH",
	Company: "Company",
	NewCompany: "New Company",
	UpdateCompany: "Update Company",
	ListOfCompanies: "List of Companies",
	TitleConfirmCompanyCreate: "Created company",
	TextConfirmCompanyCreate: "The company was successfully created",
	TitleConfirmCompanyDelete: "Deleted company",
	TextConfirmCompanyDelete: "The selected company was successfully deleted",
	TitleConfirmCompanyUpdate: "Updated company",
	TextConfirmCompanyUpdate: "The selected company was successfully updated",
	DeleteCompany: "Are you sure to delete this company? Please accept to continue",
	Confirm: "Confirm",
	MissingFieldTitle: "Missing fields",
	MissingField: "Some fields are missing in the form",
	CompanyName: "Company Name",
	CompanyFormTitleCreate: "Form to create a new company",
	CompanyFormTitleUpdate: "Form to update a company",
	CompanyConfigCrud: "Company Configuration",
	CompanyAddNewField: "Add additional field",
	CompanyConfigCrudFormTitleCreate: "Form to create a company configuration",
	CompanyConfigCrudFormTitleEdit: "Form to edit a company configuration",
	CompanyConfigCrudFormTitle: "Form to create a company configuration",
	CompanyConfNameAddLabel: "Field Name",
	CompanyConfValueAddLabel: "Value",
	CompanyConfNameAddValidMessage: "Alphabetic characters only, no spaces",
	CompanyConfValueAddValidMessage: "Please enter value here",
	DeleteCompanyConf: "Are you sure to delete this config company?",
	TitleConfirmCompanyConfigDelete: "Deleted configuration company",
	TextConfirmCompanyConfigDelete: "The selected configuration was successfully deleted",
	TitleConfirmCompanyConfigCreate: "Configuration company created",
	TextConfirmCompanyConfigCreate: "The configuration was created successfully",
	TitleConfirmCompanyConfigUpdate: "Updated configuration company",
	TextConfirmCompanyConfigUpdate: "The selected configuration was updated successfully",
	NewCompanyConfig: "New Config Company",
	UpdateCompanyConfig: "Update Config Company",
	ListOfCompaniesConfig: "List of Config Companies",
	TitleWarningExistPropertyCompanyConfig: "It already exists",
	TextWarningExistPropertyCompanyConfig: "The value to enter is already",
	UpdateCompanyConfigErrorMessage: "An error occurred while updating company settings",
	IvalidValuesErrorMessage: "invalid values",
	TypeConfig: "Configuration Type",
	NewTypeConfig: "New Type of Configuration",
	NewTypeConfigRequired: "Type of Configuration required",
	UpdateTypeConfig: "Update Type of Configuration",
	ListOfTypeConfig: "List of Configuration Types",
	InputNameTypeConfig: "Type name",
	ButtonAddTypeConfig: "Add",
	TitleConfirmTypeConfigUpdate: "Type Configuration modified",
	TextConfirmTypeConfigUpdate: "The selected configuration type was successfully modified",
	TypeConfigCrudFormTitleCreate: "Form to create a configuration type",
	TypeConfigCrudFormTitleEdit: "Form to edit a configuration type",
	TitleSuccessTypeConfigCreated: "Type Configuration created",
	TextSuccessTypeConfigCreated: "The configuration type was created successfully",
	TitleSuccessTypeConfigCreatedError: "Error creating configuration type",
	TextSuccessTypeConfigCreatedError: "The configuration type has not been created",
	DeleteTypeConf: "Are you sure to delete this configuration type?",
	TypeConfigConfigName: "Type Config Name",
	TypeConfigStatus: "Status",
	TypeConfigAddDateOn: "Added on",
	Tipology: "Typology",
	TextConfirmTipologyCreate: "Typology was create successfully",
	TextConfirmTipologyUpdate: "Typology was update successfully",
	TextConfirmTipologyDelete: "Typology was delete successfully",
	TitleConfirmTipologyCreate: "Created Typology",
	TitleConfirmTipologyUpdate: "Updated Typology",
	TitleConfirmTipologyDelete: "Deleted Typology",
	TextDeleteTipology: "Are you sure to delete the Typology ",
	TextAccepContinue: "Please accept to continue",
	Save: "Save",
	Remove: "Remove",
	Category: "Category",
	NewCategory: "New Category",
	ListOfCategories: "List of Categories",
	TitleConfirmCategoryCreate: "Created object",
	TitleConfirmCategoryUpdate: "Updated object",
	TitleConfirmCategoryDelete: "Deleted object",
	TextConfirmCategoryCreate: "The new object was created successfully!",
	TextConfirmCategoryUpdate: "The object was updated successfully!",
	TextConfirmCategoryDelete: "The object was deleted successfully!",
	Resources: "Resources",
	CreateResource: "Create resource",
	CreateObject: "Create Object",
	ResourceList: "Resource List",
	ResourceView: "Resource View",
	Objects: "Objects",
	ObjectType: "Object Type",
	NewObject: "New object",
	ListOfObjects: "List of objects",
	TooltipSchemas: `The scheme defines the minimum properties that may have objects depending on the selected type.`,
	Config: "Config",
	VisitPoint: "Visit Point",
	VisitPoints: "Visit Points",
	CreateVisitPoint: "Create Visit Point",
	UpdateVisitPoint: "Update Visit Point",
	ListVisitPoint: "Visit Point List",
	MassiveDelete: "Massive Delete",
	ActivityList: "Activity List",
	TitleConfirmActivityCreate: "Created activity",
	TextConfirmActivityCreate: "The activity was successfully created",
	TitleConfirmActivityDelete: "Deleted activity",
	TextConfirmActivityDelete: "The selected activity was successfully deleted",
	TitleConfirmActivityUpdate: "Updated activity",
	TextConfirmActivityUpdate: "The selected activity was successfully updated",
	DeleteActivity:
		"When deleting an activity, keep in mind that all associated views will also be deleted and are being managed with this activity. The selected activity is",
	DeleteActivityConfirm: "Please type the name of the activity in the following text box to continue deletion.",
	UpdateActivity: "Update Activity",
	CreateActivity: "Create Activity",
	Hours: "Hours",
	Minutes: "Minutes",
	TitleConfirmEventCreate: "Created schedule",
	TextConfirmEventCreate: "The schedule was successfully created",
	TitleConfirmEventDelete: "Deleted schedule",
	TextConfirmEventDelete: "The selected schedule was successfully deleted",
	TitleConfirmEventUpdate: "Updated schedule",
	TextConfirmEventUpdate: "The selected schedule was successfully updated",
	DeleteEvent: "Are you sure to delete this schedule? Please accept to continue",
	PopupScheduleTitleCreate: "Create new schedule",
	CreateSeveralSchedule: "Create all schedule",
	PopupScheduleTitleUpdate: "Update schedule",
	ListGroup: "Group List",
	UpdateGroup: "Update Group",
	CreateGroup: "Create Group",
	TitleConfirmGroupCreate: "Created Group",
	TextConfirmGroupCreate: "The Group was successfully created",
	TitleConfirmGroupDelete: "Deleted Group",
	TextConfirmGroupDelete: "The selected group was successfully deleted",
	TitleConfirmGroupUpdate: "Updated Group",
	TextConfirmGroupUpdate: "The selected group was successfully updated",
	ID: "ID",
	Alls: "Alls",
	VisualizeVisitPoint: "Visualize Visit Point",
	NoTracking: "No tracking",
	NotDataExecuteDescription: "No data found to paint route executed",
	NotScheduleDescription: "No scheduled appointments found to paint the route",
	NoDating: "No dating",
	NoDataAvailable: "No data available",
	ValidateField: "The {n} field is required",
	Statistics2: {
		Statistics: "Statistics",
		VisitsStatistics: "Visits statistics for the month displayed on the calendar",
	},
	Crud: {
		Create: "Create",
		Read: "Read",
		Update: "Update",
		Delete: "Delete",
		List: "List",
		Additionals: "Additional",
		Modules: "Modules",
		Cancel: "Cancel",
		Finalize: "Finalize",
		Edit: "Edit",
		Add: "Add",
		Remove: "Remove",
	},
	Languages: {
		Languages: "Languages",
		Language: "Language",
		Spanish: "Spanish",
		English: "English",
		Portuguese: "Portugués",
		French: "French",
		German: "German",
		Spa: "Spa",
		Eng: "Eng",
		Por: "Por",
		Fre: "Fre",
		Ger: "Ger",
	},
	ExportTo: {
		Points: "Export Visit Points",
		Resources: "Export Resources",
	},
	MapModule: {
		Latitude: "Latitude",
		Longitude: "Longitude",
		MapAppearance: "Map Appearance",
		Coordinates: "Coordinates",
		CopyCoords: "Copy Coordinates",
		GeoAgain: "Georeference Again",
		ActivateTraffic: "Activate traffic",
		DisableTraffic: "Disable traffic",
		Traffic: "Traffic Layer",
		Default: "Default",
		Satellite: "Satellite",
		Hybrid: "Hybrid",
		Terrain: "Terrain",
		MapOptions: "Map Options",
		Route: "Route",
		Routes: "Routes",
		SearchRoutes: "Search Routes",
		RouteType: "Route Type",
		RealTimeTracking: "Real-time Tracking",
		NoLocate: "Not was possible to locate this resource, coordinates not detected.",
		OnLine: "Online",
		OffLine: "Offline",
		LastTransmission: "Last Transmission",
		StrokeOpacity: "Stroke Opacity",
		StrokeWeight: "Stroke Weight",
		StrokeColor: "StrokeColor",
		OptimizeWaypoints: "Optimize waypoints",
		ShowWaypoints: "Show waypoints",
		ShowWaypointsText: "Show markers of the positions reported by the mobile device.",
		ShowWaypointsTextConfirm1: "Enabling the options ",
		ShowWaypointsTextConfirm2: " may cause slow rendering and fluidity of the map.",
		ShowLinearRoute: "Show linear route",
		ShowLinearRouteText:
			"Show a route executed with the real tracking of the positions reported by the mobile device without taking into account the geometry of the road.",
		ShowLabel: "Show Numbers",
		ShowLabelText: "Show label with the consecutive number of each marker.",
		ScheduledRoute: "Scheduled Route",
		ScheduledRouteZeroResult: "Could not trace a route for all of scheduled visits.",
		ExecutedRoute: "Executed Route",
		ExecutedRouteLinear: "Executed Linear Route",
		ConfigText: "Customize some of the visible properties for the routes",
		CardsView: "Cards View",
		ChangeCardsView: "Change the resource view to cards",
		ChangeListView: "Change the resource view to list",
		Georeferencer: "Georeferencer",
		GeoSub: "Georeference and locate the entered address on the map.",
		Views: "views",
		ListView: "List View",
		CardView: "Card View",
		ChangeCardView: "Change view to cards.",
		Minimize: "Minimize",
		Maximize: "Maximize",
		SeeDayScheduledRoute: "See on map the scheduled route of the day.",
		SeeDayExecutedRoute: "See on the map the executed route of the day.",
		QuotesDay: "Quotes of the day",
		SeeListQuotesDay: "See list of appointments of the day",
		GenerateRoute: {
			Title: "Error generating route.",
			Text: "No data were found for the executed route.",
		},
		ErrorGenerateAppointment: {
			Title: "Error creating appointment",
			Text: "Error consulting data",
		},
		CurrentPosition: "Current position",
		CellAutoWith: "Cell Auto Width",
		AlertVisualizarInfo: "To view the list of resources, select a group from the list at the top.",
		ResourcesNotFound: "There are no related resources found with the selected group.",
		SitidataNoEnabled: "SITIDATA API not enabled for this company.",
		TrackingInformation: "Tracking Information",
		Line: "Line",
		Points: "Points",
		Numbers: "Numbers",
		AlertRouteLinear: "This option is not enabled for routes with multiple resources",
		Georeference: "Georeference",
		GeoreferencingByAddress:
			"Georeferencing by address has been enabled to find the coordinates and locate them on the map, you must",
		DiscardTheChanges: "handle or to discard the changes click",
		GeoCoordinates: "Georeference and locate the coordinates on the map by the entered address",
		mobile_app_version: "Mobile app version",
		android_os_version: "Android OS version",
		software_details: "Software details",
		no_transmission: "no transmission",
	},
	ListCompanyConfig: {
		TypeConfigName: "Name Configuration Type",
	},
	Roles: {
		Roles: "Roles",
		SelectRole: "Please select a role",
		FormTitleRoleCreate: "Form to create a role",
		FormTitleRoleEdit: "Form to edit a role",
		CreateLabel: "Create role",
		UpdateLabel: "Edit role",
		ListLabel: "List of roles",
		FormInputRoleName: "Role Name",
		FormInputRoleAlias: "Role Name Alias",
		FormInputRoleDescription: "Role Description",
		FormInputPermit: "Permissions",
		ValidMessages: {
			ValidRoleName: "Enter a value, without special characters",
			ValidRoleDescription: "Enter a value",
			ValidRolePermissions: "Select permissions",
		},
		Permissions: {
			TitleConsultPermissionsError: "Error",
			TextConsultPermissionsError: "Error querying permissions",
			NotPermissions: "You do not have permission for this option!",
			NotPermissionsTitle: "No Permission",
			NotPermissionsText: "Contact the platform administrator for permission.",
			RequiredPermissionsText: "You need permissions for",
			JsonConfigNotFoundTex:
				"You need to create a configuration for this option. Go to the company configuration module.",
			RequiredConfig: "Required Configuration",
			RequiredConfigText:
				"is a required configuration for this process, please contact the platform administrator",
		},
		GetRoles: {
			TitleError: "Error",
			TextError: "Error querying roles",
		},
		Create: {
			Title: "Created role",
			Text: "Role created successfully",
			TitleError: "Error",
			TextError: "The role has not been created",
		},
		Update: {
			Title: "Modified role",
			TextRoleCreated: "Role Modified Successfully",
			TitleRoleCreatedError: "Error",
			TextRoleCreatedError: "The role has not been modified",
			Text: "Successful modified role",
			TitleError: "Error",
			TextError: "The role has not been modified",
		},
		ListView: {
			columnsNames: {
				Name: "Name role",
				AddedOn: "Added",
				Description: "Description",
			},
			DeleteRole: {
				TextToConfirm: "Are you sure to eliminate selected role?",
				TitleSuccess: "Eliminated role",
				TextSuccess: "The selected role has been removed",
				TitleError: "Error eliminating the role",
				TextError: "The selected role has not been removed",
			},
		},
	},
	Permissions: {
		Permissions: "Permissions",
		FormTitlePermissionCreate: "Form to create a permission",
		RequiredPermissions: "Required permissions",
		FormTitlePermissionEdit: "Form to edit a permission",
		CreateLabel: "Create permission",
		UpdateLabel: "Edit permission",
		ListLabel: "List of permissions",
		GetPermissions: {
			TitleError: "Error",
			TextError: "Error consulting the permissions",
		},
		GetRole_Permission: {
			TitleError: "Error",
			TextError: "Error consulting relationships",
		},
		GetRoles: {
			TitleConsultPermissionsError: "Error",
			TextConsultPermissionsError: "Error consulting the roles",
		},
		FormInputPermissionName: "Name permission",
		FormInputPermissionDescription: "Description",
		FormInputRoles: "Roles",
		ValidMessages: {
			ValidPermissionName: "Enter a value, without special characters",
			ValidPermissionDescription: "Enter a value",
		},
		Create: {
			Title: "Permission created",
			Text: "Permission created successfully",
			TitleError: "Error",
			TextError: "The permit has not been created",
		},
		Update: {
			Title: "Modified permission",
			Text: "Successful modified permission",
			TitleError: "Error",
			TextError: "Permission has not been modified",
		},
		ListView: {
			columnsNames: {
				Name: "Name permission",
				AddedOn: "Added",
				Description: "Description",
			},
			DeleteRole: {
				TextToConfirm: "You are sure to eliminate the selected permission?",
				TitleSuccess: "Permission deleted",
				TextSuccess: "The selected permission has been eliminated",
				TitleError: "Error eliminating permission",
				TextError: "The selected permission has not been eliminated",
			},
		},
	},
	StatusModule: {
		StatusLink: "Status",
		Create: "Create status",
		ColumnsName: {
			Name: "Status name",
			Added: "Added",
		},
		GetStatus: {
			TitleError: "Error",
			TextError: "Error consulting the status",
		},
		ValidMessages: {
			ValidName: "Enter a value, without special characters",
		},
		PopupCreate: {
			LabelTittle: "Create status",
			LabelButton: "Create",
		},
		ResponseCreate: {
			Title: "Status created",
			Text: "Status has been created correctly",
			TitleError: "Error",
			TextError: "Status has not been created correctly",
		},
		PopupEdit: {
			LabelTittle: "Edit Status",
			LabelInput: "Name Status",
			LabelButton: "Edit",
		},
		ResponseEdit: {
			Title: "Edited status",
			Text: "Status has been edited correctly",
			TitleError: "Error",
			TextError: "Status has not been edited correctly",
		},
		PopupDelete: {
			LabelText: "You are sure to eliminate the selected status?",
		},
		ResponseDelete: {
			Title: "Deleted status.",
			Text: "Status has been deleted correctly",
			TitleError: "Error",
			TextError: "Status was not deleted correctly",
		},
	},
	StatusMobile: {
		StatusMobile: "Status for mobiles",
		StatusMobileName: "Status Name for Mobile",
		ListStatusMobile: {
			ListStatusMobile: "List of Status for Mobile",
			Description: "Description",
			ActiveForm: "Active Form",
			ActiveEventToltip:
				"This option indicates whether or not in the current state it is possible to initiate events (visits) For example, activate to allow visits to start at lunch.",
			ActiveEvent: "Start Events",
			ZoneRequired: "Zone Required",
			ZoneRequiredToltip:
				"This option restricts whether or not in the mobile application (resource) it is possible to activate a state inside or outside of the resource assigned zone.",
			Status: "Status",
			Active: "Activated",
			Disabled: "Disabled",
			Company: "Company",
			ErrorTitle: "State could not be changed.",
			ErrorStatus: "The states can not be changed until the mobile has transmitted at least once time.",
		},
		FormStatusMobile: {
			CreateStatusMobile: "Create State for Mobile",
			UpdateStatusMobile: "Update State for Mobile",
			FormTitleCreate: "Form to create a status for mobile",
			FormTitleUpdate: "Form to edit a status for mobile",
			ValidMessages: {
				Name: "Enter a value, without special characters",
				Description: "Enter a value",
			},
			Create: {
				Success: {
					Title: "Status for mobile",
					Text: "Created successfully",
				},
				Error: {
					Title: "Status for mobile",
					Text: "It has not been successfully created successfully",
				},
			},
			Update: {
				Success: {
					Title: "Status for mobile",
					Text: "edited successfully",
				},
				Error: {
					Title: "Status for mobile",
					Text: "Has not been successfully edited",
				},
			},
			Delete: {
				Text: "Are you sure to delete the status for selected Mobiles?",
				Success: {
					Title: "Status for mobile",
					Text: "Deleted successfully",
				},
				Error: {
					Title: "Status for mobile",
					Text: "It has not been successfully removed",
				},
			},
		},
	},
	NewTipology: {
		name: "Write name",
		description: "Write a description here",
	},
	Resource: {
		Resource: "Resource",
		Resources: "Resources",
		DeleteResource: "Delete Resource",
		DeleteResources: "Delete Resources",
		DeleteAllResources: "Delete All Resources",
		AssigResources: "Assign Resources",
		NotResources: "No resources assigned",
		AssignResourceToltip: "Load the list of available resource to continue with the assignment.",
		ShowAssigneResource: "Show Assigned Resources",
		ShowAssigneResourceToltip: "Show the list of the assigned resources.",
		EmailInvalid: "The email address does not have a  valid format.",
		UsernameInvalid: "The username is too much short, minimum 5 characters.",
		emailRequired: "The email is required",
		identificationRequired: "The identification  is required",
		lastnameRequired: "The lastname  is required",
		nameRequired: "The name is required",
		usernameRequired: "The username is required",
		BackButton: "Back",
		FinishButton: "Finish",
		Definition: "Definition",
		ObjectProperties: "Object properties",
		Summary: "Summary",
		ObjectCreated: "Created object",
		Loading: "Loading...",
		DeleteAllText: "Are you sure to remove all resources from the table?",
		SearchMultipleId: "Search multiple results by entering ids separated by commas",
		TotalResources: "Total resources",
		NoticeNewObject: {
			Text1: "You will create a new object",
			Text2: "of type",
			Text3: "with the properties described below, please validate the information and press",
			Text4: "to proceed with creation.",
		},
		PrincipalProperties: "Principal Properties",
		Continue: "Continue",
		AdditionalProperties: "Additional Properties",
		FinalizeContent: {
			Message:
				"The new object was successfully created and ready to be used, select one of the following options to end this process",
			CreateResource: "Create Resource",
			CreateVisitPoint: "Create a Visiting Point",
			ViewAllObject: "See All Objects",
		},
		NameInvalid: {
			Title: "Name invalid",
			Text: "The name of the object does not accept accents or special characters",
			Text1: "The name of the object only accepts letters and numbers.",
		},
		SchemeInvalid: {
			Title: "Scheme invalid",
			Text: "Select a scheme to be able to continue with the creation of the object",
		},
		CorrectAllValues: "correct all values",
		List: {
			CellRenderer: {
				DeleteRecord: "You are about to delete",
				DeleteSuccess: {
					Title: "Resource deleted",
					Text: "The selected resource has been removed successfully",
				},
			},
		},
		Create: {
			TabLabel: "Create Resource",
			LoadResourcesType: "Loading resource types!",
			ReosurceType: "Resource type",
			SelectType: "Select the object type to render the form.",
			Success: {
				Title: "Resource created",
				Text: "A new resource was created in the system.",
			},
		},
		Edit: {
			EditResource: "Edit Resource",
			UserNotFound: {
				Text1: "User record with id:",
				Text2: "not found.",
				Check: "Check",
				AllUsers: "All Users",
			},
			ValidMessages: {
				Username: "The username field is required, without special characters or spaces",
				Email: "The email field is required, with the correct format",
				Status: "The status field is required",
				Lastname: "The lastName field is required",
				Identification: "The identification field is required",
				Nombre: "The name field is required, without special characters or numbers",
				Role: "The role field is required",
				Dynamic: {
					Text1: "The",
					Text2: "field is required",
				},
				VisitPointInactive:
					"It is not possible to update the resource because it has inactive or not found visit points assigned, please check the visit points with id:",
			},
		},
		View: {
			AssignedActivities: "Assigned activities",
			NotAssignedActivities: "No activities assigned",
			NotImeiCode:
				"It does not have an imei code registered, it is possible that the resource has never logged in from the mobile application",
		},
	},
	ErrorVariable: {
		Textvariable1: "The field is missing or incorrect!",
	},
	Object: {
		Object: "Object",
		CreateObject: "Create Object",
		AdditionalFields: "Additional Fields",
		AdditionalField: "Additional Field",
		NotAdditionalFields: "The object does not have additional fields",
		PrincipalFields: "Principal Fields",
		TypeField: "Type Field",
		Required: "Required",
		Yes: "Yes",
		Not: "Not",
		Label: "Label",
		LabelHelp: "Name visible on the form",
		Options: "Add options write: ( Option value: Color in English )",
		OptionsLabel: "Example: Option1:Black",
		Property: "Property",
		Properties: "Properties",
		PropertyDefinition: "Property Definition",
		EnableEditing: "Enable editing",
		ChangeName: "Change name",
		SaveChanges: "Save Changes",
		TypeName: "Type name",
		EnterNewName: "Enter the new name",
		ChangeObjectName: "Change object name",
		ObjectName: "Object name",
		TypeLabel: "Type label",
		Basics: "Basics",
		ValidMessages: {
			name: "The name field is required, without special characters or spaces",
			label: "The label field is required",
			status: "The status field is required",
			cat: "The category field is required",
		},
		DeleteObject: {
			Text1: "Are you sure to eliminate the object",
			Text2: "Please accept to continue.",
		},
		DeleteField: {
			Text1: "Are you sure to eliminate the field",
			Text2: "Please accept to continue.",
		},
		NumProperties:
			"Select a schema to see the minimum properties that the object may have or as well as to be able to add new properties of this.",
		SelectSchemeLabel: "SELECT SCHEME",
		SelectSchemeValue: "SELECT_SCHEME",
		SelectedTipology: {
			label: "resources",
		},
		Field: {
			label: "Text",
		},
		statusOptions: {
			Date: "Date",
			DateTime: "DateTime",
			Text: "Text",
			Number: "Number",
			Email: "Email",
			Url: "Url",
			Select: "Selection",
			File: "File",
			Image: "Image",
			Coordinates: "Coordinates",
			DefaultLocation: "Default Location",
			Radio: "Several options",
			Checkbox: "Checkbox",
			Dropdown: "Dropdown",
			Switch: "Boolean",
			Composed: "Composed",
			MultipleChoice: "Multiple choice",
		},
		nameOptions: {
			VISIT_POINT: "VISIT POINT",
			RESOURCE: "RESOURCE",
			SCHEDULE: "SCHEDULE",
			LAYER: "LAYER",
		},
		ErrorFields: {
			Title: "Error in fields",
			Text: "Some fields are missing or invalid!",
		},
		UserDeleted: {
			Title: "User Deleted",
			Text: "The selected user was successfully deleted.",
		},
		UserInvalid: {
			Title: "Name invalid",
			Text: "The name of the object only accepts letters and numbers.",
		},
	},
	VisitPointObject: {
		Create: {
			SelectObjectType: "Select object type",
			ValidMessages: {
				ObjectType: "The type of object is required",
				Name: "The name field is required",
				Identification: "The identification field is required, without special characters or spaces",
				Phone: "The phone field is required",
				Address: "The address field is required",
				Country: "The country field is required",
				Departament: "The department field is required",
				City: "The city field is required",
			},
			LabelInfoObjectType: "Please select the type of object for the creation of the visiting point.",
			GeoFindNextAddress: "The georeferenceder found the following address for the new coordinates:",
			UseAddressQuestion: "Do you want to use this address for the visit point?",
			Success: {
				Title: "Visiting point created",
				Text: "A new point of visit was created.",
			},
			ErrorRegisterValidate: {
				Title: "Missing Fields",
				Text: "Missing fields in additional information",
			},
			FindAddress: {
				Title: "Direction found",
				Text: "Georeferentiated address successfully.",
			},
			ErrorFindAddress: {
				Title: "Address not found",
				Text: "The georeferencer did not find the address entered",
			},
			MissingAddress: {
				Title: "Address is Required",
				Text: "The address is required by the georreferencer.",
			},
			ErrorFindCountry: {
				Title: "Coverage not found",
				Text: "Check that the chosen country matches the country where you are dragging the marker",
			},
			GeoRefFindAddress:
				"The georeferenceder found a new address for the new  n coordinates wants to replace the address by",
			WithoutResource: "You haven't assigned any resources,  are you sure to continue?",
		},
		Edit: {
			VisitPointNotFound: {
				Title: "Visit Point not found",
				Text1: "Visit point record with id:",
				Text2: "not found.",
			},
			AllVisitPoints: "All Visit Points",
			ValidMessages: {
				ObjectType: "The type of object is required",
				Name: "The name field is required",
				Identification: "The identification field is required, without special characters or spaces",
				Phone: "The phone field is required",
				Address: "The address field is required",
				Country: "The country field is required",
				Departament: "The department field is required",
				City: "The city field is required",
				Status: "The status field is required",
			},
			Success: {
				Title: "Visit Point Update",
				Text: "The visit point was successfully updated",
			},
			Error: {
				Title: "Updating Error",
				Text: "An error occurred during the update",
			},
		},
		List: {
			CellRenderer: {
				DeleteRecord: "You are about to delete",
				DeleteSuccess: {
					Title: "Visit Point Deleted",
					Text: "The selected visit point was successfully deleted",
				},
			},
			MassiveDelete: {
				Confirm: {
					Title: "Massive Elimination",
					Text: "Are you sure to continue with the elimination of visiting points?",
				},
				Success: {
					Title: "Visit Point Deleted",
					Text: "The selected visit point was successfully deleted",
				},
			},
			SelectVisitPoint: {
				Title: "Select visit points",
				Text: "You have not selected any point of visit",
			},
			NotSchedule: "Not Scheduled",
			InvalidRangeOfDateTitle: "Invalid Dates Range",
			InvalidRangeOfDateMsj: "The range of days between dates cannot exceed 31.",
		},
		Assig: "Assign",
		AssignVisitPoints: "Assign visit points",
		AssignedVisitPoint: "Assigned visit point",
		AssignedVisitPoints: "Assigned visit points",
		NoAssignedVisitPoints: "There are no assigned visit points",
		AssigneVisitPointText: "Select the viewpoints you want to assign.",
		AssignedResourceByZonesTextAlert:
			"The allocation of resources by zones to the visit points is active. If you delete resources from the list, it is possible that after saving the changes, some of them will not be unassigned due to this configuration",
		Columns: "Columns",
		ColumnsText: "Select the columns you want to render in the table",
		AssignVisitPointToltip: "Load the list of available visit points to continue.",
		AssignAllVisitPointText: "Assign all platform visit points",
		TotalVisitPoints: "total visit points",
	},
	Activity: {
		Activity: "Activity",
		AssignedResources: "Assigned Resources",
		AssignedGroups: "Assigned Groups",
		AssignedGroupsError: "An error occurred while getting the assigned groups.",
		AlertMissingForm: 'It is necessary to select a form if the "Active Form" option is activated.',
		AlertFormNotFoundTitle: "Form not found.",
		AlertFormNotFoundText: "The activity has a form assigned but it is not in the list of available forms.",
		ActivateForm: "Active Form",
		Form: "Form",
		ServiceTime: "Service Time",
		Activated: "Activated",
		Inactivated: "Inactivated",
		ActivityListEmpty: "There are no activities",
		ActivityHasNoAssignedResources: "The activity has no assigned resources",
		Activities: "Activities",
		AssignActivities: "Assign activities",
		AssignedActivities: "Assign activities",
		LoadActivityListToltip: "Load the list of available activities to continue with the assignment.",
		TotalActivities: "Total activities",
		DRPointsRequired: "Dr Points required, minimum 0 to continue",
	},
	ActivityValidMessages: {
		ItemName: "The name field is required",
	},
	Schedule: {
		Schedules: "Schedules",
		SelectionMode: "Selection Mode",
		AdditionalFields: "Additional Fields",
		AdditionalFieldsAlert: "If you want to add or edit additional fields you must select a type of object.",
		AddNewVisit: "Visit Selections",
		SelectResource: "Select Resource",
		Refresh: "Refresh",
		ResourceList: "Resource List",
		SearchSchedule: "Search Schedule",
		CancelVisit: "Cancel Visit",
		ActivityNoAvailable: "Activity not available for the resource, please go to the activities and assign it.",
		Repeat: "Repeat",
		CurrentVisitPointAssigned: "Current Visit Point Assigned",
		ToAssigVisitPoint: "Click on search button to assig one.",
		ActiveApi: "Activate Api",
		SchedulingApiNotEnabled: "Scheduling api not enabled for this company.",
		ServiformApiNotEnabled: "Serviforms api not enabled for this company.",
		Month: "Month",
		Week: "Week",
		Day: "Day",
		ErrorProcess: {
			Title: "Error",
			Text: "An error occurred during the process",
			InitHourError: "The start time cannot be less than the current time",
			VisitpointError: "The selected visit point is not assigned to the selected resource",
			ResourceActivityError: "The selected activity is not assigned to the selected resource",
		},
		SelectInitTime: "Select initial time",
		SelectEndTime: "Select end time",
		ValidEndOur: "The final hour can not be less than the initial time.",
		ValidDinamicFields: {
			Text1: "The",
			Text2: "field is required",
		},
		AssignVisitPointText: "Please assign a visiting point to create the appointment.",
		SelectVisitPointText: "Select the visiting point you want to assign to the appointment.",
		SelectVisitPointTextAlarm: "Select the visiting points that you want to assign to the alarm.",
		None: "NONE",
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		Sunday: "Sunday",
		MondayToFriday: "From monday to friday",
		EveryDay: "Every day",
		MondayToSaturday: "FROM MONDAY TO SATURDAY",
		MondayAndFriday: "TUESDAY AND THURSDAY",
		MondayWednesdayAndFriday: "MONDAY,WEDNESDAY AND FRIDAY",
		Weekend: "WEEKEND",
		WeekMayus: "Weekly",
		MonthMayus: "Monthly",
		Finished: "Finalized",
		Finalize: "Finalize Visit",
		InProgress: "In Progress",
		ReProgramming: "Reprogrammed",
		Canceled: "Canceled",
		Scheduled: "Scheduled",
		InvalidFields: "Invalid Fields",
		ValidData: {
			Title: "Validate the data",
			Text: "Some important fields are missing",
			DayLessThanCurrentDayTitle: "Invalid day",
			DayLessThanCurrentDay: "The day of the visit must not be less than the current day.",
		},
		SelectResourceText: "Select a resource to view events in the calendar",
		ListofEventsDay: "List of events for the selected day",
		SelectDateToSeeEvents: {
			Text1: "Select the",
			Text2: "date",
			Text3: "to see the events.",
		},
		EventsOnTheMap: "Events on the map",
		Reassign: "Reassign Visits",
		ReassignTextConfirm:
			"To re-assign successfully visits, the selected resource must have to same activities assigned. Please accept to continue.",
		ReassignTextError:
			"visits couldn't be re-assigned, please be sure the selected resource has the required activities assigned.",
		ReassignDate: "New date reassign.",
		CreateVisit: "Create Visit",
		CreateVisits: "Create Visits",
		OnTheWay: "On the way",
		Delayed: "Delayed",
		NotAssigned: "Not Assigned",
		Visit: "Visit",
		ReassingResourceText: "Please select a resource from the list to reassign visits",
		FilterVisitPointBy: "Filter visit point by",
		ReviewVisits: "Review Visits",
		DeleteVisit: "DeleteVisit",
		DeleteVisitTextConfirm: "Are you sure to delete this visit from the system?",
		FilterByAdditionalFields: "Filter information by additional fields",
		FilterByAdditionalFieldsText:
			"Select the type of object and assign the values to each of the properties by which you want to filter the information.",
		ReadyVisitsToAssign: "Visits Ready to Assign",
		ReadyVisitsToAssignText:
			"The following visits are ready to be assigned to the resource. You can delete them or click the assign button to complete the process.",
		NotReadyVisitsToAssign:
			"There are no visits ready to assign, complete the form information and click the add visit button.",
		AddVisit: "Add Visit",
		VisitInformation: "Visit Information",
		VisitInformationText: "Complete the visit information and click the add visit button to continue.",
		AssignResource: "Assign Resource",
		AssignResourceText: "Select the resource you want to assign the visit to.",
		OpenAvailableResources: "Open Available Resources",
		ClickToOpenAvailableResources: "Click to open the list of available resources",
		ClickOnEditVisit: "Click the edit button to modify the visit information.",
		UpdateVisitInformation: "Update Visit Information",
		UpdateVisitInformationText: "Update the visit information and click the reschedule button to save the changes.",
		RescheduleVisit: "Reschedule Visit",
		ConfirmActionQuestion: "Are you sure to {n} the visit? This action cannot be undone.",
		VisitScheduling: "Visit Scheduling {n}",
		VisitSchedulingText:
			"You can schedule one or multiple visits at a time, complete the visit information and click the add visit button.",
		VisitRescheduling: "Visit Rescheduling {n}",
		VisitReschedulingText:
			"It is only possible to reschedule one visit at a time, update the visit information and click the reschedule button.",
		ScheduleVisits: "Schedule Visits",
		ViewCalendar: "View Calendar",
	},
	DeleteGroup: {
		Text1: "Are you sure to delete the group",
		Text2: "Please accept to continue.",
	},
	GroupValidMessages: {
		ItemName: "The name field is required",
		ItemAddress: "The address field is required",
	},
	Groups: {
		Groups: "Groups",
		TotalGroups: "Groups Total",
		Group: "Group",
		AssigneGroup: "Asign Group",
		AssignGroups: "Asign Groups",
		AssignedGroup: "Assigned Group",
		AssignedGroups: "Assigned Groups",
		AssigneGroupToltip: "Load the list of available groups to continue with the assignment.",
		ShowAssigneGroup: "Show Assigned Groups",
		NoAssignedGroups: "There are no assigned groups",
		ShowAssigneGroupToltip: "Show the list of the assigned groups.",
		AssigneGroupRequired: "La assignation of the group is required",
		ClickOnButton: "Click on button",
		DeleteAllGroups: "Delete all of groups",
		AvailableGroups: "Available groups",
		Favorite: "Favorite",
		FavoriteConfirmText:
			"Set as the default group for broadcast viewing when you log in to the platform, you can quickly view and change it from the top bar",
		AskForAgain: "Ask for again",
		DefaultGroup: "Default Group",
		FavoriteRemoveConfirmText:
			"Remove the default group selection option from the top bar of the platform. You can activate it again from the platform preferences",
	},
	Alarm: {
		Alarm: "Alarm",
		Alarms: "Alarms",
		BatteryAlarms: "Battery Alarms",
		RadioAlarm: "Schedule Start and Close Alarm",
		Radio: "Radius",
		DefineRadius: "Establish radio",
		GpsAlarms: "GPS Alarms",
		UpdateAlarm: "Update Alarm",
		CreateAlarm: "Create Alarm",
		BatteryLevel: "Battery Level",
		AlarmList: "Alarms List",
		ScheduleAlarms: "Schedule Alarms",
		TotalVisit: "Total Visits",
		AssignedEmails: "Assigned Emails",
		NoAssignedEmail: "No assigned emails",
		ZoneAlarms: "Zone Alarms",
		ZoneAlarmsType: "Type",
		SelectAll: "SELECT ALL",
		MissingFields: {
			Title: "Missing fields",
			Text: "The battery level must be greater than 0 and less than 100",
		},
		ValidFields: {
			Name: "The name field is required",
			EndTime: "The end time field is required",
			Email: "The email field is required and should be a valid email",
		},
		SelectInitTime: "Select initial time",
		SelectEndTime: "Select end time",
		AssignedResources: "Assigned Resources",
		AssignedZones: "Assigned Zones",
		AddResources: "Add Resources",
		LoadListResources: "Load list of resources to assign to the alarm.",
		DeleteResources: "Delete Resources",
		DeleteAllResources: "Delete all resources.",
		DeleteAllVisitPoints: "Delete all visit points.",
		DeleteEmails: "Remove emails",
		DeleteAllEmails: "Eliminate all emails",
		NotAssignEmail: "No assigned emails",
		DeleteAllText: "You are about to delete all",
		ErrorGetResourceFilter: {
			Title: "Error",
			Text: "An error occurred by consulting assigned resources.",
		},
		DeleteYouAre: "You're about to erase",
		MissingFieldsSchedule: {
			Title: "Fields are missing",
			Text: "The total number of visits must be greater than 0",
			Text2: "The zone is a value required",
		},
		ZoneTypes: {
			Input: "Input",
			Output: "Output",
			InputAndOutput: "Input and Output",
		},
		TitleConfirmAlarmCreate: "Created Alarm",
		TextConfirmAlarmCreate: "The alarm was successfully created",
		TitleConfirmAlarmDelete: "Deleted Alarm",
		TextConfirmAlarmDelete: "The selected alarm was successfully deleted",
		TitleConfirmAlarmUpdate: "Updated Alarm",
		TextConfirmAlarmUpdate: "The selected alarm was successfully updated",
		ValidInitHour: "The init hour cannot be greater than or equal the end hour.",
		ValidEndHour: "The end time cannot be less than or equal to the start time.",
		DateInitError: "The start date cannot be greater than the end date.",
		AssignateTo: "Assign alarm to",
		EventToNotify: "Kind of event to notify",
		Start: "Beginning visits",
		End: "Closing visits",
		Startandend: "Beginning and closing visits",
		SpeedAlarm: "Speed Alarm",
		Speed: "Speed",
		ValidSpeed: "Speed must be between 1 and 200",
		ValidSpeedRequired: "Speed field is required",
	},
	Zonification: {
		Zonification: "Zonification",
		View: "View",
		Draw: "Draw",
		ReplacePolygonConfirmTitle: "Replace Polygon",
		ReplacePolygonConfirmText: "Are you sure to replace the polygon of the currently selected zone?",
		Tools: "Tools",
		AlertTextOne: "Please select the resource that you will associate with the zones through the option",
		DeleteZoneResourceConfirmTitle: "Delete Assignation",
		DeleteZoneResourceConfirmText:
			"Are you sure to delete all of the assigned zones with this resource? Please accept to continue.",
		DeleteAssignationSuccess: "Assignation Was Delete",
		DeleteAssignationSuccessText: "All of zones were successfully unassigned from the resource.",
		CreateAssignationSuccess: "Assignation Created",
		CreateAssignationSuccessText: "The assignation of zones was successfully created.",
		UpdateAssignationSuccess: "Assignation Update",
		UpdateAssignationSuccessText: "The assignation of zones was successfully update.",
		AlertSelectLayerTitle: "Select Layer and Zones",
		AlertSelectLayerText:
			"Now select a layer to see the list of available zones to assign to the selected resource.",
		AlertSelectLayerText2: "Use the button",
		AlertSelectLayerText3: "to save the changes made or ",
		AlertSelectLayerText4: "to delete the current assignations.",
		Zone: "Zone",
		Zones: "Zones",
		ZonesNotFound: "No information on assigned zones was found or they were removed from the system.",
		AssignedZone: "AssignedZone",
		Circle: "Circle",
		Rectangle: "Rectangle",
		Polygon: "Polygon",
		Polyline: "Polyline",
		Marker: "Marker",
		FillColor: "FillColor",
		NewLayer: "New Layer",
		EditInfo: "Edit Info",
		RemoveZones: "Remove Zones",
		Layer: "Layer",
		EditName: "Edit Name",
		Layers: "Layers",
		UseTool: "Use the Tool",
		DrawAndAddZones: 'To draw and add zones to the layer, which will be listed in the drop-down "Zones"',
		AssignNameLayer: "Please assign a layer name.",
		NameLayer: "Name of the layer",
		EditZoneSelected: "Information from the selected area, assign a new name or a description.",
		AddZoneInLayer: "To add this area to the layer, assign a name and a description",
		AddZone: "Add Zone",
		CreateNewLayer: "Create New Layer",
		UpdateNameLayer: "Update Name Layer.",
		DragToRelocate: "Drag to relocate",
		CurrentPosition: "Current position",
		UpdateLayerSuccess: {
			Title: "Updated Layer",
			Text: "The name of the layer is updated correctly.",
		},
		RemoveLayer: {
			Title: "Layer removed",
			Text: "Layer successfully removed.",
		},
		UpdateZone: {
			Title: "Updated Zone",
			Text: "The area of the zone was successfully modified",
			Text2: "Information of the zone is successfully updated.",
		},
		AddZones: {
			Title: "Zone Added",
			Text: "New zone added to the current layer.",
		},
		ErrorInsertZones: {
			Title: "Error adding",
			Text: "An error occurred by adding the new area to the layer, try again.",
		},
		ErrorRemoveZones: {
			Title: "Delete failed",
			Text: "An error occurred during the elimination of zones, try again.",
		},
		RemoveLayerMessage: {
			Title: "Layer Removed",
			Text: "The layer and all its zones were correctly removed.",
		},
		RemoveZoneMessage: {
			Title: "Zone Removed",
			Text: "The selected zones were correctly removed.",
		},
		RemoveZonesInLayer: {
			Title: "Removed layer",
			Text: "The layer and all its zones were removed successfully.",
		},
		ErrorRemoveZonesInLayer: {
			Title: "Error Removed",
			Text: "An error occurred during the elimination of all zones of the layer, try again.",
		},
		RemoveLayerConfirmation: {
			Title: "Remove Layer.",
			Text: "Are you sure you delete the entire layer and its respective zones?",
		},
		ErrorUpdateZoneInfo: {
			Title: "Error updating",
			Text: "Error during the update of the information, try again.",
		},
		SelectZones: {
			Title: "Select Zones",
			Text: "You have not selected any zone.",
		},
		ConfirmRemoveLayerAndZones: {
			Title: "Confirm elimination",
			Text: "Are you sure to eliminate the entire layer and respective zones?",
		},
		ConfirmRemoveSelectedZones: {
			Title: "Confirm elimination",
			Text: "Are you sure to delete all selected areas?",
		},
		UploadZones: {
			SelectFileText: "Select a file to start the load",
			FileName: "Select File",
			Success: {
				Title: "Upload Success",
				Text: "The file was successfully uploaded",
			},
			Error: {
				Title: "Upload Error",
				Permission: "User doesn't have permission to access the object",
				Cancel: "User canceled the upload",
				Unknown: "Unknown error occurred, inspect error.serverResponse",
			},
		},
		FormGeo: {
			FindCoords: "The georeferenceder found the following address for the new coordinates:",
			AskUseDirection: "Do you want to use this address for the visit point?",
			FindDirection:
				"The georeferencer find a new direction for the new coordinates \n You want to replace the address by",
		},
	},
	UploadFiles: {
		UploadFiles: "Upload Files",
		UploadSuccess: "Upload Success",
		UploadSuccessMessage: "The file was uploaded successfully.",
		UploadError: "Upload Error",
		UploadErrorMessage:
			"An error occurred while uploading the file, please check if the file has the basic structure or download the example files",
		UploadType: "Upload Type",
		UploadTypeSelectToltip: "Defines the file upload type.",
		UploadTypeObjectToltip: "Defines the structure of the file to load taking into account its additional fields.",
		UploadTypeCountryTooltip: "Select the country where the visiting points to upload will be georeferenced.",
		SelectFile: "Select File",
		UploadSuccessTextAlert:
			"The file was uploaded successfully and is being processed in the background, check or wait for system notifications to know the status of the process.",
		FileReadyToBeUploaded: "File ready to be uploaded.",
		Details: "Details",
		Size: "Size",
		DownloadFailed: "Download failed",
		DownloadFailedText: "Download failed, file not found or was removed from the server",
		FileNotFound: "File not found",
		DownloadFormat: "Download basic file",
		DownloadFormatText:
			"Download a base or template file in the selected format that contains the required structure for the selected upload type",
		Format: "Format",
		InvalidFormatFile: "Invalid format file",
		InvalidFormatFileText:
			"Please select a file with the correct format to continue with the upload only .xlsx, .xls, .csv, .json or .xml files are allowed",
	},
	Reports: {
		Report: "Report",
		Reports: "Reports",
		GenerateReport: "Generate a report",
		GenerateReportInfo: "To generate a new report, select the type of report you want to generate",
		AlertTextOne: "Please select the resources associated with the report through the option",
		AlertTextTwo: "to continue with the process.",
		NoDataReportTitle: "No data found",
		NoDataReport: "No data found for this type of report.",
		NoDataReportInDates: "No data were found for established dates.",
		ReportGeneratedTitle: "Report Generated",
		ReportGeneratedText: "The report was generated successfully.",
		loginout: "Login Logout",
		scheduledroute: "Scheduled Route",
		scheduledroutevsexecuted: "Scheduled Route vs Executed",
		location: "Location",
		LocationDescription: "This report returns the last position of the resources",
		historicalposition: "Historical Position",
		HistoricalpositionDescription: "This report exports all the positions where the resource has been transmitted",
		transmission: "Transmission",
		TransmissionDescription: "This report returns the total transmission time in one business day.",
		EndDateLessToday: "The end date must be less than today",
		DateRequired: "Missing fields, date is required",
		RangeExceeds: "date range exceeds ninety (90) days",
		EndDateGreaterInitDate: "The end date must be greater than init date",
		EndDateGreaterOrEqualInitDate: "The end date must be greater or equal than the init date",
		DateInitMustBeLessToday: "For this type of report, the date must be less than today",
		General: "General Resource Report",
		Single: "Single Resource Report",
		Multiple: "Multiple Resource Report",
		AlertTextLogin: "The general report do not need to assignations of resources",
		Generate: "Generate",
		History: "History",
		DeleteAllText: "Are you sure to delete all resources?",
		SelectFileTitle: "Generate Report",
		SelectFile: "Select the file type",
		Error: "An error occurred. Please try again!",
		ShowFiles: "Show Files",
		FileName: "File Name",
		TotalFiles: "Total Files",
		DownloadReports: "Report History",
		MaxResourcesReached: "This kind of report can't be generate for more than 10 resources",
		ReportType: "Report Type",
		ProcessingReport: "Processing a report",
		HistoricalpositionText:
			"This report is processed in the background and the platform will notify you of its status through the notification module at the top",
		ReportProcessFinish: "Now, you can find the result file in the history report to download it",
		ReportSetDateRange: "Set a date range: For the selected report a maximum of is allowed",
		ReportSetFileType: "Select the type of file you want to generate",
		visitpoint: "Visit Points",
		VisitpointReportDescription:
			"This report returns the information of the selected visit points, dividing the data into separate files by type of object",
		MultipleVisitPoints: "Multiple Resources Report",
		resource: "Resources",
		ResourceReportDescription:
			"This report returns the information of the selected resources, dividing the data into separate files by type of object",
		id: "ID",
		report_type: "Report Type",
		date_init: "Date Init",
		date_end: "Date End",
		resource_id: "Resource ID",
		added_on: "Added On",
		update_on: "Update On",
		total_download_file: "Total Download File",
		download_file_id: "Download File ID",
		sort_by: "Sort By",
		sort_by_description:
			"Select the field(s) by which you want to sort the list of reports, with the selected fields taking priority from left to right",
		sorting_type: "Sorting Type",
		ascendent: "Ascending",
		descendent: "Descending",
		filter_by: "Filter By",
	},
	Indicators: {
		Indicators: "Indicators",
		IndicatorList: "Indicator List",
		CreateIndicator: "Create Indicator",
		TitleConfirmIndicatorCreate: "Created Indicator",
		TextConfirmIndicatorCreate: "The indicator was successfully created",
		TitleConfirmIndicatorDelete: "Deleted Indicator",
		TextConfirmIndicatorDelete: "The selected indicator was successfully deleted",
		TitleConfirmIndicatorUpdate: "Updated Indicator",
		TextConfirmIndicatorUpdate: "The selected indicator was successfully updated",
		DeleteIndicator: "Are you sure to delete this indicator? Please accept to continue",
		UpdateIndicator: "Update Indicator",
		Visualizer: "Visualizer",
		AlertVisualizar: "Visualize Indicator",
		AlertVisualizarInfo: "To view an indicator, click on an item in the list that you want to view.",
		IndicatorNotFound: "There are not indicators or doesn't exists",
		Indicator: "Indicator",
	},
	Communication: {
		Communication: "Communication",
		Message: "Message",
		Messages: "Messages",
		NewMessage: "New Message",
		MessageReply: "Write your reply message here",
		Seen: "Seen",
		Unseen: "Unseen",
		MarkAs: "Mark as",
		Resolved: "Resolved",
		PendingForResolved: "Pending for resolved",
		AlertVisualizarInfo:
			"To view messages, click an item in the resource list for which you want to view your messages.",
		NoMessages: "There are no messages.",
		NoMessagesText: "The selected resource does not have any messages.",
		DeleteMessages: "Delete Messages",
		DeleteMessagesText: "Are you sure to delete the selected messages? Please accept to continue.",
		WaitingToResolve: "Waiting to resolve",
		UnresolvedMessages: "Unresolved Messages",
	},
	Notification: {
		Notification: "Notification",
		Notifications: "Notifications",
		DeleteAllNotifications: "Delete all notifications",
		UPLOAD_FILE: "Notifications about upload file",
		DOWNLOAD_FILE: "Notifications about download file",
		EVENT: "Notifications about calendar",
		New: "New",
		NewNotification: "New Notifications",
		AppNotifications: "App Notifications",
		NEW_EVENT: "NEW EVENT",
		EVENT_NOT_ASSIGNED: "EVENT NOT ASSIGNED",
		RESCHEDULED_EVENT: "RESCHEDULED EVENT",
		EVENT_IN_PROCESS: "EVENT IN PROCESS",
		EVENT_ENDED: "EVENT ENDED",
		EVENT_CANCELLED: "VISIT CANCELLED",
		EVENT_ON_THE_WAY: "ON THE WAY TO VISIT",
		EVENT_DELAYED: "IN DELAY TO VISIT",
		FINALIZED: "PROCESS FINALIZED",
		LOADED: "FILE LOADED",
		PROCESS: "FILE IS IN PROCESS",
		DOWNLOAD_FINALIZED: "Download Finalized",
		PANIC_ALARM: "Panic Alarm",
		PanicAlarmText: "A panic alarm was reported by one of the resource on the field",
		CheckOut: "Check Out",
	},
	Login: {
		Subtitle: "Welcome, login to use the platform.",
		Email: "Email",
		Password: "Password",
		Remember: "Remember me",
		ForgotPassword: "Forgot Password?",
		Register: "Register",
		Disabled: "The user account has been disabled by an administrator.",
		Login: "Login",
		PasswordWasRestored: "The password was successfully restored",
		PasswordIsNotSecure: "The password is not secure please type other one",
		EmailDoesNotExist: "The email does not exist or does not have an associated uid",
		PleaseVerifyCode: "Please verify code",
		PasswordIsNotsecure: "The password is not secure please type another",
		LoginAttemptTitle: "Login attempt",
		LoginAttemptText: "¡You are already logged in!",
		ValidMessages: {
			Email: "The Email field is required and should be a valid email",
			Password: "The password is required, minimum 6 characters - maximum 18",
			InvalidPassword: "The password is invalid or the user does not have a password.",
			UserNotFound: "Something went wrong validating the credentials",
			TooManyRequests:
				"Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
			text: " minimum 6 characters - maximum 18",
			CompanyReachedWorkingDate: "The company reached the date of work",
			InvalidCode: "Invalid authentication code",
		},
		LoginWithGoogle: "Login with Google account",
		EnableTwoFactorAuthentication: "Enable two factor authentication",
		TwoFactorAuthentication: "Tow factor authentication",
		TwoFactorAuthenticationText:
			"Enter the 6-digit code that was sent to you by email to continue with the authentication",
		ResendAuthCodeEmail: "If the message with the authentication code hasn't arrived, you can request a resend.",
		ResendCode: "Resend code",
		CodeSent: "Verification code sent",
	},
	RecoverPassword: {
		Title: "Recover password",
		Subtitle: "Please enter your email address and we'll send you instructions on how to reset your password.",
		Email: "Email",
		ToLogin: "To Login",
	},
	ResetPassword: {
		TitleReset: "Reset password",
		TitleCreate: "Create password",
		Subtitle: "Please enter your new password.",
		VerificationCode: {
			Title: "Verification code",
			Text1: "A verification code was sent to the email. if the code does not arrive,",
			Text2: "send it again",
		},
		Code: "Code",
		YourPassword: "Your password",
		ConfirmPassword: "Confirm Password",
		ToLogin: "To Login",
		Reset: "Reset",
		ValidPassword1: "The password field must be at least 6 characters",
	},
	CompanyForm: {
		nameRequired: "The field name is required",
		addressRequired: "The field address is required",
		phoneRequired: "The field phone is required",
		nitRequired: "The field company nit is required",
		date_initRequired: "The field date init is required",
		date_endRequired: "The field date end is required",
		contac_personsRequired: "The field contact persons is required",
		cityRequired: "The field city is required",
		countryRequired: "The field country is required",
		descriptionRequired: "The field description is required",
		InvalidFields: "Invalid Fields",
		ChechInfo: "Please check the information, if all right, click on the Save button to finish the process.",
		ViewCompanyList: "Click here to go to the list of companies",
		AdminResource: "Administrator Resource",
		AdminResourceSuccess: "Administrator resource was create successfully",
		AdminResourceError: "Administrator resource could not be created",
		AdminResourceFailed:
			"Something went wrong during the creation of the Administrator Resource. try to create it again from the companies list.",
		DateInitError: "The start date cannot be greater than the end date.",
		CompanyInformation: "Company Information",
		Summary: "Summary",
		Finish: "Finish",
		ActivateServiroutes: "Select the administrator resource for the activation of servoutes.",
		ActivateSitidadaText1: "It is necessary to activate SITIDATA for a correct functioning of the platform",
		ActivateSitidadaText2: "click here to add configuration.",
		RequiredConfig: "Required Configurations",
		EmailAlreadyExist: "There is already a registered user with this email.",
		ValidEmail: "Email valid",
		ReleationShip: "Relationship with visit points",
	},
	ManualData: {
		Required: "Required",
		InformationFound: "Information found",
		ErrorsFound: "Errors found during the upload information process",
		ErrorsNotFound: "No errors found during the information upload process",
		ValidatorRequiredProperty: "is a required property, please remove it",
		AlreadyRegistered: "Already registered",
		DateLessThanCurrentDate: "Date less than current date",
		NotRegistered: "Not registered",
		ValidatorAdditionalProperties: "Additional properties are not allowed, delete its",
		TooShortProperties: "Property value is empty or content is too short",
		country: "Country",
		city: "City",
		address: "Address",
		identification: "Identification",
		phone: "Phone",
		name: "Name",
		cx: "CX",
		cy: "CY",
		date: "Date",
		ManageError: "Manage Errors",
		ProcessAgain: "Process Again",
		ProcessAgainText:
			"Reprocess the file; this will try to create new records on the system, so note that the records must not exist.",
		ProcessAgainTextSuccess:
			"Reprocess the file is working in the background, please check or wait for the system notifications to know the status process.",
		DownloadFile: "Download File",
		Download: "Download",
		AddedOn: "Added",
		PropertyError: "Error on the property",
		ShowErrors: "Show Errors",
		FixErrorsHere: "Fix errors here",
		FixErrorsModule: "Fix errors on module",
		SaveChanges: "Save changes",
		ActivityNotRegistered: "Activity is not registered",
		EditAlertText: "Edit the selected property, respect its format and note that some values must exist.",
		Property: "Property",
		ResourceHasNoActivities: "Resource do not have any activities",
		SaveRecordError: "Save record error",
		DaneCodeNotFound: "Dane code not found",
		DuplicateRecordInExcel: "Duplicate record in excel",
		InitHourLessThanCurrentTime: "Init hour less than current time",
		ErrorEndHour: "Error on end hour",
		ErrorInitHour: "Error on init hour",
		ErrorDate: "Error on date",
		CoordinatesCouldBeNotFound: "Coordinates could be not found",
		AddressCouldBeNotGeoreferenced: "Address could be not georeferenced",
		TimeDataFormat:
			"The format is not valid, the correct format should be similar for date YYYY-mm-dd  or time HH:mm:ss",
		SitidataGeoreverseToken: "The Sitidata api georeverse token is not enabled for this country",
		InvalidValue: "has an invalid value, only character strings are allowed",
	},
	Record: {
		ListRecord: "Record List",
		RecordNumber: "Record Number",
		UpdateRecord: "Update Record",
		CreateRecord: "Create Record",
		DeleteRecord: "Delete Record",
		DeleteRecordConfirmText: "Are you sure to delete this record from system? Please accept to continue.",
		TitleConfirmRecordCreate: "Created Record",
		TextConfirmRecordCreate: "The Record was successfully created",
		TitleConfirmRecordDelete: "Deleted Record",
		TextConfirmRecordDelete: "The selected record was successfully deleted",
		TitleConfirmRecordUpdate: "Updated Record",
		TextConfirmRecordUpdate: "The selected record was successfully updated",
	},
	Routing: {
		Optimization: "Optimization",
		Resource: "Resource",
		Routing: "Route visit points",
		DistanceRoute: "Distance",
		MinimumRouteTime: "Route time",
		Typology: "Typology",
		SelectedColumns: "Columns Selected",
		DeparturePointOptionsTex: "Select one of the options to add a start point or an end point",
		DeparturePoint: "Departure Point",
		StartingPoint: "Starting point",
		FinalPoint: "End point",
		FromMapTitle: "Select a point on the map by clicking on the desired position or by dragging the marker",
		FromMapAlert: "Select a point on the map by clicking on the desired position",
		FromMap: "Enables the function of being able to select a point from the map by clicking where you want",
		FromVisitPoint: "Allows you to assign the point from the system's list of visit points",
		FromGroup: "Allows you to assign the point from the list of system groups",
		FromAdditionalFields: "Allows you to assign the point from the additional location type fields of the objects",
		Point: "Point",
		NoFoundDefaultPoint:
			"No default starting point found for resource, click continue, configure one through the Add Point option",
		ConfigureInitHour: "Set a start time for optimization and click the continue button",
		AcceptOptimization: "This will update all calendar events with the information proposed by the optimization",
		ErrorOptimization:
			"An error occurred during optimization, please try again. If the error persists, contact the platform administrator",
		DateLessThanCurrentDate: "The optimization date cannot be less than the current date",
		RescheduledEvents: "Rescheduled Events",
		RescheduledEventsText: "The events were successfully rescheduled",
		OverlapEventsWarning:
			"To avoid calendar overlap some visits had scheduled dates for later days, please check the highlighted views",
		SuccessOptimization: {
			TextOne: "Optimization completes successfully, review the result",
			TextTwo: "click here",
			TextThree: "or on the button",
			TextFour: "to accept the result and update the events in the calendar",
		},
		Buttons: {
			Process: "Process Route",
			Next: "Next",
			Optimize: "Optimize",
			SeeRoute: "See Route",
			Validate: "Validate",
			OtherFields: "Add to others fields",
			AddVisitPoint: "Add Visit Point",
			EditVisitPoint: "Edit",
			NextResources: "Next, Select Resources",
			ExportRoute: "Export route",
			SeeAllRoutes: "See Routes",
			Schedule: "Schedule",
			DeleteRoute: "Delete route",
		},
		Table: {
			Type: "Type",
			Name: "Name",
			AddedOn: "Added On",
			Action: "Action",
			Actions: "Actions",
			Identification: "Identification",
			Longitude: "Longitude",
			Latitude: "Latitude",
			EstimatedTimeArrival: "Estimated Time Arrival",
			TimeService: "Service Time",
			TimeWindowInit: "Init Time",
			TimeWindowEnd: "End Time",
			Cx: "Latitude",
			Cy: "Longitude",
			Demand: "Demand",
			InitHour: "Init Hour",
			EndHour: "End Hour",
			Skills: "Skills",
			Row: "Excel Row",
			Column: "Excel Column",
			Error: "Error",
		},
		Title: {
			ResourceList: "Resources List",
			VisitPointsList: "Visit Points List",
			SelectFormat: "Select format",
			Close: "Close",
			MatchColumn: "Match Column",
			TableExample: "Uploaded File Data Example",
			TableExampleText: "Below is a preview of the data found in the uploaded file",
			ProcessVisitPoints: "Process Visit Points",
			EditVisitPoint: "Edit Visit Point",
			VisitPoints: "All your visit points",
			VisitPointsLocations: "Visit Points Locations",
			Resources: "Resources",
			OptimizeByTeam: "Filter by team",
			SelectResource: "Select the resources to export the route",
			Errors: "Errors Found",
			UploadVisitpoints: "Upload visit points",
			UploadVisitpointsList: "List uploaded files",
			ExportFromDataRutas: "Export Rutify Visiting Points",
			RoutingHistory: "Routing History",
			Schedule: "Schedule",
			RoutingMode: "Select routing type",
			Basic: "Basic",
			Logistic: "Logistics",
			Selection: "Selection",
			AssignBulkActivity: "Assign Bulk Activity",
			AssignActivity: "Assign activity to all of checked visit points.",
		},
		Map: {
			MapAppearance: "Map Appearance",
			Types: "Map Type",
			Styles: "Map Style",
			ClickToDownload: "Click to download",
			ShowMap: "Show map",
			HideMap: "Hide map",
			ExportRoute: {
				Error: "The route could not be exported",
				Success: "Route exported successfully",
			},
			Schedule: {
				OptionalDate: "Date (Optional)",
				ClickToSchedule: "Click to schedule",
				Success: "Schedule request sent, to verify use the Rutify calendar",
				Error: "An error occurred and your schedule was not sent",
			},
			VisitPoints: {
				Drop: "Drop Visit Point",
				Dropped: "Visit Point Dropped",
				Identifier: "Identifier",
				TimeArrival: "Time to arrival",
				Deposit: "Deposit",
			},
			DeleteRoute: {
				DeleteRouteAsk: "Are you sure, you want delete the current route?",
				Success: "Route removed successfully",
			},
		},
		RouteResult: {
			Title: "Route Result",
			ResourcesRouted: "Resources Routed",
			ResourcesNotRouted: "Resources Not Routed",
			RoutesTime: "Total minimum time all routes",
			TotalDistance: "Total Distance",
			VisitPointsRouted: "Visit Points Routed",
			VisitPointsNotRouted: "Visit Points Not Routed",
		},
		Messages: {
			upload_placeholder: "Drag your files here or click to add a file",
			MatchColumn:
				"Keys and values equivalent to the column names given in the file to be processed, for routing.",
			MatchColumnSelectionRouting:
				"Mapping equivalencies between columns found in the file and the properties required by the routing process.",
			MatchColumnSelectionRoutingP2:
				"Select after each column name found in the file the value corresponding to the equivalence of the load.",
			MatchColumnSelectionRoutingP3:
				"Through the 𝐚𝐝𝐝 option of the list, we can add the columns as additional values ​​to the result of the routing process, the rest of the columns will be omitted.",
			MatchColumnSelectionRoutingP4:
				"Once the assignment is finished, click on the button 𝐆𝐮𝐚𝐫𝐝𝐚𝐫 to continue with the selection on the map.",
			MatchColumnSelectionRoutingError: "The following equivalences were missing to be assigned: ",
			MatchColumnSelectionRoutingErrorTitle: "Error Equivalences",
			MatchColumnSelectionRoutingErrorEquivalents: "It is necessary to assign the equivalences of the columns",
			SelectedColumns:
				"Column names that you want to keep and that appear in the routing response, the rest of the fields will be omitted.",
			ErrorMsg: "Please fix this errors on your excel file and try to upload it again.",
			AlertRoutingHistory:
				'Remember that you can re-optimize a previously loaded route, using the "optimize" function and selecting new resources.',
			AlertProccessing: "We are working to optimize your routing, we will notify you when it is completed.",
			SelectSchedule: "Select your resources to schedule",
			DataRutasVisitPointsSelect:
				"This is your list of visit points in Rutify, to route using these points, select them and choose a route type",
			AssignEquivalents: "Column Equivalency Assignment",
		},
	},
	RoutesLegends: {
		ProgramedRoutes: "Programed Routes",
		ExecutedRoutes: "Executed Routes",
		TotalVisits: "Total Visits",
		Distance: "Distance",
		Time: "Time",
		ViewZones: "View the assigned zones to the resources.",
		SpeedReached: "Speed Reached",
	},
	Statistics: {
		Statistics: "Statistics",
		VisitsStatistics: "Visits statistics for the month displayed on the calendar",
	},
	Setting: {
		Setting: "Setting",
		NewConfiguration: "New Configuration",
		VisualSetting: "Visual Setting",
		ThemeColor: "Theme Color",
		NavbarColor: "Navbar Color",
		ConfirmSave: "Do you want to save the applied changes?",
		Saved: "Changes saved successfully",
		SelectCompany: "Select the company to configure",
		AllowedLogo: "Allowed image files JPG or PNG. Max size of 900kB",
		ImageNotAllowed: "Image not allowed",
		ChooseImage: "Choose Image",
		UploadImage: "Upload Image",
		DeleteImage: "Are you sure to delete the image?",
		ImagenUploaded: "Image has been uploaded successfully",
	},
	OnDemand: {
		OnDemand: "On Demand",
		AssigResource: "Assign Resource",
		SearchResources: "Search Resources",
		Automatically: "Automatically",
		Manually: "Manually",
		FindResources: "Resources within a set maximum radius",
		SetRadiusOnMapTitle: "Set radius on map.",
		SetRadiusOnMapText: "You can now draw the resource search radius from the map",
		AvailableResources: "Resources available for assignment",
		NoAvailableResources: "Discarded resources",
		NoAvailableResourcesText:
			"No resources available for assignment found, click the view discarded resources button for more information",
		NoAvailableResourcesDateText:
			"No resources were found available for the assignment, the visit belongs to days after the current date, to continue I reassigned the visit to a date equal to or greater than the current one",
		AlertVisualizarInfo: "To view and manage an appointment, click on an item from the list on the right.",
		Distance: "Distance",
		Notify: "Notify",
		ResourcesWereNotified: "All resources were notified",
		ResourcesAssigned: "Visit was assigned to the resource successfully",
		DateAssignedEnded: "The deadline to assign this visit has already ended",
		ConfirmAssign: "Are you sure to continue with the visit assignation to the resource?",
		NoFoundEvents: "No found events to assign",
		AutomaticAllocation: "Automatic resource allocation",
		AutomaticAllocationText:
			"Enabling automatic resource allocation prevents new events from being available for allocation from this dashboard",
		AutomaticAllocationTextAlert:
			"If automatic resource allocation is active, it will prevent new events from being displayed on this dashboard",
		Enabled: "Enabled",
		Disabled: "Disabled",
		AvailableResourcesText:
			"Resources with availability on date and time of visit (Agenda, Activity and Assignment with point)",
		AvailableResourcesZone: "in the same area as the point",
		AvailableResourcesZoneRelated: "Resources assigned to the same zone of the viewpoint",
		AvailableResourcesEvents: "Resources with a maximum number of visits assigned",
		AvailableResourcesLocation: "Find resources taking into account the coordinates of",
		AvailableResourcesLocationTracking: "Tracking",
		AvailableResourcesLocationTrackingTitle: "Current position reported by field resources",
		AvailableResourcesLocationDefault: "Default location",
		AvailableResourcesLocationDefaultTitle: "Additional resource property to establish a default location point",
		SetFilters: "Set search criteria",
		NotifyOnCreateEnabledWarning:
			"To activate the automatic allocation of resources, it is necessary that in the configuration of ON_DEMAND the value of notify_on_create is false",
		DisabledMapBtnTitle:
			"Tracking on the map will be available once the resource changes the status of the visit to on the way",
		TrackingOnTheMap: "Tracking on the map",
		ScheduledHour: "Scheduled hour",
		ExecutedHour: "Executed hour",
		DistanceToPoint: "Aerial distance to the point",
		ReachedThePoint: "Has reached the point",
		RequestedVisits: "Requested Visits",
		AssignedVisits: "Assigned Visits",
		NotAssignedVisits: "Not Assigned Visits",
		ViewResourceCalendar: "View the resource's calendar",
		AvailabilityFilters: "Availability filters",
		LocationFilters: "Location Filters",
		SearchResultAlert:
			"Click on the markers corresponding to the resources to see their information. If at least one of the location filters is checked, the zones assigned to the resource that intersect with the visit point will be displayed",
		Free: "Free",
		NotifyAllResources: "Notifique todos os recursos",
		NotDistance: "Outside the established radius",
		NotAvailability: "Does not count availability in agenda, activity or assignment with the point of visit",
		NotLocation: "Not location",
		NotEvents: "Exceeds the maximum number of visits assigned",
		NotLocation1: "No active transmission",
		NotLocation2: "Does not have default location",
		NotRelatedZone: "Does not have any related zone where the visit point is",
		NotLocationZone: "Not located in the same zone as the visit point",
		DiscardedBy: "Discarded by",
		SendNotify:
			"Notify resources, creates an auction between all available resources to accept or reject the visit. Do you wish to continue ?",
		SelectDateRange: "Select Date Range",
		ChangeDate: "Change Date",
		ChangeDateText: "Allows you to set a range of dates to view unmanaged visits from subsequent days",
		HideVisitListOnSelect: "Hide visit list when selecting one",
		ShowList: "Show list",
		HideList: "Hide list",
	},
	FormMessages: {
		RequiredName: "The name field is required",
		RequiredLastname: "The lastname field is required",
		RequiredIdentification: "The identification field is required",
		RequiredEmail: "The email field is required",
		InvalidEmail: "The email field must be a valid email",
		RequiredUsername: "The username field is required",
	},
	MassiveAssignment: {
		MassiveAssignment: "Massive Assignment",
		SelectedResources: "Selected Resources",
		SelectedVisitPoints: "Selected Visit Points",
		ShowAssignedVisitPointToltip: "Show the visit points currently assigned to this resource.",
		SelectVisitPoints: "Select Visit Points",
		SelectResources: "Select Resources",
		MaxSelectedResources: "Select a minimum of one resource and a maximum of four to continue.",
		MaxSelectedResourcesReached: "Maximum resource selection reached",
		MaxSelectedVisitPoints: "Select at least one visit point to continue.",
		VisitPointsConfirmAssign: "Continue assigning visit points to the selected resources?",
		VisitPointsAssignationSuccessText: "The visit point assignment was successful.",
		UploadFileNote:
			"If you have a file of previous massive assignments you can upload it here, otherwise continue with the resource selection",
		MassiveAssignmentUploadFile: "Select massive assignment file",
		LoadMassiveAssignmentUploadFile: "Load file to recovery previous selections",
		LoadMassiveAssignmentUploadFileError: "The file does not have a valid format to upload the information",
		ConfirmAssignText:
			"Check Save, if you want to generate an archive with the information of the selected visiting points, which will allow you to recover this selection in later assignments.",
	},
	general: {
		AllFieldsRequired: "All fields are required to continue",
		MapAppearance: "Map Appearance",
		MapTypes: "Map Types",
		MapStyle: "Map Style",
		WelcomeToRutify: "Welcome to Rutify",
		LoginDescription: "Log in and start enjoying your platform.",
		Email: "Email",
		Emails: "Emails",
		Remember: "Remember Me",
		RememberPassword: "¿Do not you remember your password?",
		ForgotPassword: "Reset your password here",
		Styles: "Styles",
		VisitPoints: "Visit Points",
		VisitingPointsDescription: "Select the visit points you want to locate on the map.",
		Status: "Status",
		GpsStatus: "GPS Status",
		Navigation: "Navigation",
		ClearMap: "Clear Map",
		SubTitleZonification: "Create and manage zones on the map",
		Selectt: "Select",
		DescriptionResource: "Select the resources to assign in the new visit point",
		SubTitleObject: "Know and manage the status of your orders",
		SubTitleProperty:
			"Select a schema to see the minimum properties the object can have or to add new properties to it",
		SubTitleResource: "Create and manage new resources and their distributions",
		SubTitleResourceUpdate: "Update resources and their distributions",
		Image: "Image",
		SubtitleVisitPoint: "Select the visit points in the new resource",
		SubtitleGroups: "Select the groups to assign",
		SubtitleGroupsActivity: "Select the groups to assign in the new activity",
		SubtitleGroupsIndicator: "Select the groups to assign in the new indicator",
		SubtitleResource: "View and manage new resources and their distributions",
		SubtitleReassing: "Select the new resource to reassign the selected visits",
		SubtitleVisitPoint2: "View and manage available visit points",
		SubtitleDetailedInformation: "Detailed information of a",
		SubtitleGroupsList: "View and manage the available groups and resources in each one",
		SubtitleGroupsCreate: "Select the resources to assign in the new visit point",
		SubtitleGroupsUpdate: "Update the resources assigned at the point of visit",
		SubtitleAssignedVisits: "View and manage the tracking of assigned visits",
		SubtitleOnDemand: "Create and manage unassigned visits on the map",
		User: "User",
		Scheduled: "Scheduled",
		NotAssigned: "Not Assigned",
		Rescheduled: "Rescheduled",
		OnTheWay: "On The Way",
		InProgress: "In Progress",
		Finalized: "Finalized",
		Clear: "Clear",
		Account: "Account",
		LocationInformation: "Location Information",
		Visualize: "Visualize",
		Return: "Return",
		New2: "New",
		Activities: "Activities",
		Relevant: "relevant",
		Batteries: "Batteries",
		Load: "Load",
		Archive: "Archive",
		ForgetYourPassword: "¿Forget your password?",
		NoDataFound: "No data found",
		BacktoStart: "Back to Start",
		RemoveSelection: "Remove Selection",
		SelectYourFile: "Select your file",
		FormActivation: "Form activation",
		Hour: "Hour",
		Initial: "Initial",
		End: "End",
		Of: "of",
		SubtitleActivity: "View and manage available activities",
		SubtitleActivityCreate: "Enter the pertinent data for the new activity",
		SubtitleActivityUpdate: "Update activities and their distributions",
		SubtitleVisitPointUpdate: "Update and manage visiting points",
		SubtitleAlarmSchedule: "View and add",
		SubtitleAlarmSchedule1: "relevant",
		SubtitleAlarmSchedule2: "alarms",
		SubtitleAlarmCreate: "Enter the pertinent data for the new alarm",
		SubtitleAlarmUpdate: "Updates the relevant data assigned to this alarm",
		SubtitleUploadFile: "View and manage object files",
		SubtitleUploadFileCreate: "Enter the pertinent data for the new file upload",
		SubtitleReports: "Generate and download reports according to the selected indicator",
		SubtitleIndicators: "Select and view the indicators you want to analyze",
		SubtitleIndicatorsCreate: "Enter the pertinent data for the new indicator",
		SubtitleIndicatorsUpdate: "Updates the relevant data assigned to this indicator",
		SubtitleCommunication: "Maintain constant communication with your resources",
		SubtitleStatusMobile: "View and manage mobile statuses",
		SubtitleStatusMobileCreate: "Enter the pertinent data for the new state",
		SubtitleStatusMobileUpdate: "Updates the relevant data assigned to this state",
		SubtitleRadiusCreate: "Enter the pertinent data for the new alarm",
		SubtitleRadiusUpdate: "Updates the relevant data assigned to this alarm",
		SubtitleRol: "View and manage the roles generated by resource",
		SubtitleForgetPassword:
			"Enter your email address. We will send the instructions to follow in order to reset your password.",
		SubtitleCompany: "View and manage the available companies",
		SubtitleTypology: "View and manage the available typology",
		SubtitleConfigCompany: "View and manage every available company configuration",
		SubtitleStatus: "View and manage every available state",
		SubtitlePermissions: "View and manage every available permission",
		SubtitleTypeConfig: "View and manage each type of configuration available",
		SelectAllResources: "Select all resources",
		SelectAllVisitPoints: "Select all visit points",
		RelationShipDescription:
			"Relation of the resources against the points of visit: all (relation all against all, a resource can serve any point of visit), multi (relationship one to many, a point of visit can be served by several resources) and mono (relationship one to one)",
		Raster: "Trama",
		RasterInformation: "Raster information",
		Geofence: "Geofence",
		SelectedZonesOnTheMap: "Select up to six zones to view on the map",
		NoZonesAssigned: "There are no zones assigned to this resource",
		MaximumResourceReport: "Select a maximum of three resources",
		ZonesAllowedOnTheMap: "The number of zones allowed to display on the map is six",
		NoResultsFoundFor: "No results found for",
		SearchResourceBy: "Search resource by",
		TheRole: "The role",
		ValidateRoleResource:
			"does not allow the relationship of visit points, groups or activities, to do it you must select the role EXECUTIVE or SUPERVISOR",
		ValidateAssignVisitPointResource: "You need to define the role of the resource in the required information",
		NoModule: "The company does not have the module or it is not active",
		Images: "Images",
		Files: "Files",
		EmailAlreadyAdded: "This email has already been added",
	},
	CreatePasswordVP: {
		SecurityValidation: "Security Validation",
		Question: "Question",
		ToValid: "To validate",
		QuestionsText: "Which of the following options does the user have a relationship with in the system?",
		RequiredAnswer: "Please select an option to continue",
		NoFoundCode: "Code not found",
		NoFoundCodeText: "Please check or try to generate another code",
		PasswordRestored: "Password Restored",
		PasswordRestoredText: "The password was restored or created successfully",
		ValidationCode: "Validation code",
		WriteCode: "Write the code received by text message",
		EnableOnDemandUser: "Enable On-Demand User",
		SentCode: "A verification code was sent to the phone number",
		GoTo: "Go to",
		CodeExpired: "Code has Expired",
		CodeBlocked: "Code Blocked",
		CodeExpiredText: "The code has expired, request a new code with the administrator",
		CodeMaximumAttempts:
			"The code has exceeded the maximum number of 3 validations, request a new code with the administrator",
		BadAnswersText:
			"One or more of the selected validation responses do not match the visit point data, please request a new code with the administrator to try again",
		OnDemandUser: "On Demand User",
		EnableOnDemandUserText:
			"To enable an On Demand user to a point of visit, it is necessary to send a verification code to the mobile phone that you want to link to the record",
		CellphoneAlreadyRegister: "The mobile number is already registered in this company",
		VisitPointAlreadyRegister: "The visit point already has an user registered in this company",
		CellphoneNoValid: "the mobile number sent is not a valid number",
	},
	Preferences: {
		Preferences: "Preferences",
		FilterSearchTitle: "Type of searches",
		FilterSearchNote: "Only works when searching through additional fields",
		FilterSearchText:
			"Allows you to establish whether the search for visit points or resources is strictly equal to the specified criteria or if the search takes coincidences into account",
		FindExactly: "Search by exact criteria",
		FindCoincidence: "Find by match",
		NumberDays: "Number of days",
		NotificationNumberDays:
			"Configure the number of previous days from which the platform will load and display notifications",
		NotificationNumber:
			"Set the maximum number of notifications that can be displayed since the last notification received",
		DeleteOldNotification:
			"When launching the platform, automatically delete notifications older than the previous days established previously",
	},
	Chat: {
		Chat: "Chat",
		Members: "Members",
		LeaveGroup: "Leave the group",
		LeaveGroupText: "Are you sure you want to leave the group?",
		ClearHistory: "Clear History",
		DeleteMemberText: "Are you sure you want to delete the member from the group",
		DeleteChatText: "Are you sure you want to delete the chat?",
		ViewGroupInfo: "View group info",
		GroupAdded: "Welcome to the group",
		TypeYourMessage: "Type Your Message",
		SearchOrStartANewChat: "Search or start a new chat",
		SearchContact: "Search contact",
		Contacts: "Contacts",
		StartConversation: "Start Conversation",
		Online: "online",
		NoContactFound: "No Contact Found",
	},
	Modules: {
		Modules: "Módulos",
		ACTIVITY: "ACTIVITY",
		ALARMS: "ALARMS",
		CALENDAR: "CALENDAR",
		CHAT: "CHAT",
		COMMUNICATION: "COMMUNICATION",
		COMPANY: "COMPANY",
		COMPANYCONFIG: "COMPANY CONFIG",
		GROUPS: "GROUPS",
		INDICATORS: "INDICATORS",
		MAP: "MAP",
		MASSIVE_ASSIGNMENT: "MASSIVE ASSIGNMENT",
		OBJECTS: "OBJECTS",
		ON_DEMAND: "ON_DEMAND",
		PERMISSION: "PERMISSION",
		REPORTS: "REPORTS",
		RESOURCES: "RESOURCES",
		ROLE: "ROLE",
		SERVIFORMS: "SERVIFORMS",
		SERVIROUTES: "SERVIROUTES",
		STATUS: "STATUS",
		STATUSMOBILE: "STATUS MOBILE",
		STATUSMOBILEMANAGEMENT: "STATUS MOBILE MANAGEMENT",
		TYPE_CONFIG: "TYPE CONFIG",
		TYPOLOGY: "TYPOLOGY",
		UPLOAD_FILES: "UPLOAD FILES",
		VISIT_POINT: "VISIT POINT",
		ZONIFICATION: "ZONIFICATION",
		SESSION_API: "SESSION_API",
	},
	SessionApi: {
		SessionApi: "Session API",
		AccessToken: "Access token",
		ExpireDate: "Expire date",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copy",
		Copied: "Copied",
		CopiedText: "Token copied to clipboard successfully",
	},
	DesignConfig: {
		MinimumCharacterLength: "Minimum character length",
		MaximumCharacterLength: "Maximum character length",
		MinimumVal: "Minimum value",
		MaximumVal: "Maximum value",
		Option: "Option",
		SwitchText: "Switch active / inactive",
		SelectMinimumOneOption: "Select Minimum One Option",
		LoadOptions: "Load options list",
		CalendarStatus: "Calendar status",
		Composed: "Composed",
		AllowValues: "This property can receive one of the following values",
	},
	CompanyModule: {
		MissingServiceTime: "Missing service time",
		Month: "Month",
		Year: "Year",
		Day: "Day",
		Month: "Months",
		Year: "Years",
		Day: "Days",
		AllDescription: "The visit points of the platform can be attended by any resource ",
		MonoDescription: "The visit point can only be served by one resource",
		MultiDescription: "The visit point can be served by several resources",
		AdminResourceDescription:
			"The administrator resource is the first resource of the company and which is required to add configurations such as SERVIROUTES",
		AccessToken: "Access token",
		GenerateAccessToken: "Generate access token by API",
	},
	EventTracking: {
		EventTracking: "Event Tracking",
		EventStatusBtn: "Check",
		Tracking: "Tracking",
		TrackingText: "Please enter the unique code provided to track the progress, status, and details of the event.",
		TrackingCode: "Tracking Code Example: 10000a19t45b1738b77877",
		TrackingCodeRequired: "The tracking code is required",
		TrackingCodeInvalid: "The tracking code is invalid",
		EventDetails: "Event Details",
		EventDetailsText:
			"Essential information about the event status will be displayed, ensuring the confidentiality of sensitive data.",
		TrackingHistory: "Status Change History",
		NextStops: "Next Stops",
		Location: "Location",
		EstimatedTimeArrival: "Estimated Time of Arrival",
		EstimatedTimeArrivalNextStop: "Estimated Time of Arrival at the next stop",
		EventNotFound: "Event not found",
		Message: "Message",
		EventNotFoundText:
			"The event you are looking for is not in our records. Please check the entered code and try again.",
		EventScheduleInformation: "Event Schedule Information",
		ScheduleDate: "Schedule Date",
		ScheduleInitHour: "Scheduled Start Time",
		ScheduleEndHour: "Scheduled End Time",
		Print: "Print",
		Updates: "Updates",
		AlphaNumeric: "Only alphanumeric characters are allowed and a maximum of 22 characters",
	},
	Waypoint: {
		Waypoint: "Waypoint",
		Waypoints: "Waypoints",
		WaypointText:
			"A waypoint is a point of interest that must be visited before reaching the visit point, to perform a delivery or pickup task",
		WaypointList: "Waypoint List",
		SelectWaypoint: "Select Waypoint",
		SelectWaypointText: "Select a waypoint to view its information",
		NoWaypointFound: "No waypoints found",
		NoWaypointFoundText: "No waypoints found in the selected visit",
		WaypointDetails: "Waypoint Details",
		WaypointsConfiguration: "Waypoints Configuration",
		WaypointConfiguration: "Waypoint Configuration",
		WaypointConfigurationText:
			"Configuration of the waypoints that must be attended by the resource before reaching the visit point",
		Delivery: "Delivery",
		Pickup: "Pickup",
		order: "Order",
		cx: "Latitude",
		cy: "Longitude",
		job_type: "Job Type",
		priority: "Priority",
		service_time: "Service Time",
		capacity: "Capacity",
		OrderText: "Order in which the waypoint should be attended",
		JobTypeText: "Type of job to be performed at the waypoint",
		PriorityText: "Priority of attending the waypoint ranges from 0 to 10, where 10 is the highest priority",
		WaypointInformation: "Waypoint Information",
		EnterWaypointInformation: "Enter the waypoint information to continue",
		NotWaypointAdded: "No waypoint added",
		AddWaypoints: "Add Waypoints",
		AddWaypointText:
			"To add a waypoint, click on the desired location on the map and complete the requested information or use the add button to geo-reference an address",
		ReorderWaypoints: "Reorder Waypoints",
		ReorderWaypointsText: "To reorder the waypoints, drag and drop the waypoints in the desired order on the list",
		OpenWaypointConfiguration: "Open waypoint configuration",
		CloseWaypointConfiguration: "Close waypoint configuration",
		OpenWaypointConfigurationView: "Click to open or close the waypoint configuration view",
		WaypointConfigurationNotAvailable: "Waypoint configuration is only available for creating one visit at a time",
		WaypointConfigurationNotAvailableText:
			"To configure waypoints, you must first add a visit to the visit list to assign to the resource",
		WaypointsReordered: "Waypoints reordered successfully",
		ServiroutesErrorCreate: "An error occurred while processing the waypoints in Serviroutes",
		WaypointsRouteFetched: "Route for waypoints fetched successfully",
		RoutingFetchError: "Error fetching route for waypoints",
		MaxWaypointsReached: "Maximum number of waypoints reached",
	},
	Follower: {
		Follower: "Follower",
		Followers: "Followers",
		FollowersText: "Followers are users who are notified of changes in the status of a resource's visit or event.",
		FollowersList: "Followers List",
		SelectFollower: "Select Follower",
		SelectFollowerText: "Select a follower to view their information",
		NoFollowerFound: "No followers found",
		NoFollowerFoundText: "No followers were found for the selected visit",
		FollowerDetails: "Follower Details",
		FollowersConfiguration: "Followers Configuration",
		FollowerConfiguration: "Follower Configuration",
		FollowerConfigurationText:
			"Configuration of followers who will receive notifications about a resource's visits",
		FollowBy: "Followed by",
		FollowersInformation: "Follower Information",
		EnterFollowerInformation: "Enter the follower's information to continue",
		NotFollowerAdded: "No follower has been added",
		AddFollowers: "Add Follower",
		AddFollowerText: "To add a follower, enter a phone number or email address and click the add button",
		SelectEvent: "Select Event",
		SelectEventText:
			"Choose the visit to which you want to add followers. If accessed from the calendar, the visit will be automatically selected.",
		SearchEvent: "🔍 Search event...",
		SearchEventText: "Search for an event by resource name or event identifier",
		SearchEventNotFound: "No events found",
		SelectNotificationChanel: "Notification Channels and Types",
		SelectNotificationChanelText:
			"Choose through which channel you want to receive notifications about the resource's events. You can select one or more channels.",
		SelectNotificationChanelText2:
			"Choose the event status for which you want to receive notifications. You can select one or more statuses.",
		Email: "Email",
		Sms: "Text Message (SMS)",
		WhatsApp: "WhatsApp",
		RecipientSettings: "Recipient Settings",
		RecipientSettingsEmail: "Email Settings",
		RecipientSettingsSmsOrWhatsApp: "SMS or WhatsApp Settings",
		RecipientSettingsText: "Enter the recipient information for each selected notification channel",
		RecipientSettingsTextAlertText:
			"Please select at least one notification channel to continue with the configuration",
		RecipientSettingsEmailText:
			"Enter the email addresses to which notifications will be sent. You can add multiple addresses separated by commas.",
		RecipientSettingsEmailPlaceholder: "Example: example@email.com, another@email.com",
		RecipientSettingsEmailPlaceholderList: "List of added emails (with delete option)",
		RecipientSettingsEmailError: "Enter at least one email address",
		RecipientSettingsEmailErrorInvalid: "Enter a valid email address",
		RecipientSettingsEmailErrorDuplicate: "The email address has already been added",
		RecipientSettingsSmsOrWhatsAppText:
			"Enter the phone numbers to which notifications will be sent via SMS or WhatsApp. Remember to include the country code.",
		RecipientSettingsSmsOrWhatsAppPlaceholder: "+1 1234567890, +1 9876543210",
		RecipientSettingsSmsOrWhatsAppPlaceholderList: "List of added phone numbers (with delete option)",
		RecipientSettingsSmsOrWhatsAppError: "Enter at least one phone number",
		RecipientSettingsSmsOrWhatsAppErrorInvalid: "Enter a valid phone number",
		RecipientSettingsSmsOrWhatsAppErrorDuplicate: "The phone number has already been added",
		Template: "Template",
		Templates: "Templates",
		TemplateSettings: "Template Settings",
		TemplateSettingsText:
			"The template defines the structure and content of the message notifications that will be sent to event followers",
		SelectTemplate: "Select Template",
		SelectTemplateText: "Choose the template that will be used to send notifications to followers",
		TemplateText: "Template Text",
		PleaseSelectTemplate: "Please select a template to view its structure and content here",
		SelectTemplateError: "Select a template to continue",
		email: "Email",
		cell_phone: "Phone Numbers",
		in_event_status: "In Event Status",
		template_name: "Template Name",
		whatsapp: "WhatsApp",
		sms: "SMS",
		to_email: "Emails",
		event_id: "Event Identifier",
		email_error: "At least one email is required if the email notification channel is selected",
		cell_phone_error:
			"At least one phone number is required if the SMS or WhatsApp notification channel is selected",
		in_event_status_error: "At least one event status is required",
		template_name_error: "The template name is required",
		event_id_error: "Please select a visit to continue",
		NoEmailsYet: "No emails have been added",
		NoCellPhonesYet: "No phone numbers have been added",
		NoEventStatusYet: "No event statuses have been selected",
		SelectLanguage: "Select Language",
		SelectVisit: "Select Visit",
		SearchVisit: "Search Visit",
		SearchVisitByDate: "Search Visit by Date",
		SetDateRange: "Set Date Range",
		SearchVisitByDateText: "Search for a visit by start date or set a date range for more results",
		SelectVisitText: "Choose the visit to which you want to add followers",
		SearchVisitText: "Search for a visit by resource name or visit identifier",
		SearchVisitNotFound: "No visits found",
		SelectLanguageText: "Choose the language in which you want to receive notifications",
		ConfigCompanyRequired: "The company must have the {id} configuration to continue with this functionality",
		PleaseContactAdmin: "Please contact the platform administrator to activate this configuration for the company",
		alreadyExistToPhoneNumber:
			"The visit already has a notification assigned for the {id} status via SMS or WhatsApp with the phone number ",
		alreadyExistToEmail:
			"The visit already has a notification assigned for the {id} status via email for the email address ",
	},
};
